import { ref } from 'vue'
import type {
  TaxPackDetailLevel,
  TaxPackExportContext,
  TaxPackExportOptions,
} from '@/types/taxPack'

const SESSION_KEY = 'swiftaid_statement_pdf_export_prefs'

const isOpen = ref(false)
const pendingContext = ref<TaxPackExportContext | null>(null)
const detailLevel = ref<TaxPackDetailLevel>('detailed')

function loadSessionPrefs() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY)
    if (!raw) return
    const parsed = JSON.parse(raw) as Partial<TaxPackExportOptions>
    if (parsed.detailLevel === 'basic' || parsed.detailLevel === 'detailed') {
      detailLevel.value = parsed.detailLevel
    }
  } catch {
    // Ignore invalid session preferences.
  }
}

function saveSessionPrefs(options: TaxPackExportOptions) {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(options))
  } catch {
    // Ignore quota errors.
  }
}

/** Shared PDF download modal, options sent to GET /me/statements/:period/pdf. */
export function useTaxPackExportModal() {
  const openTaxPackExportModal = (context: TaxPackExportContext) => {
    pendingContext.value = context
    loadSessionPrefs()
    isOpen.value = true
  }

  const closeTaxPackExportModal = () => {
    isOpen.value = false
    pendingContext.value = null
  }

  const resolveExportOptions = (): TaxPackExportOptions => {
    const context = pendingContext.value
    const options: TaxPackExportOptions = {
      includeDonorAdded: Boolean(context?.hasManualSection),
      detailLevel: detailLevel.value,
    }
    saveSessionPrefs(options)
    return options
  }

  return {
    isOpen,
    pendingContext,
    detailLevel,
    openTaxPackExportModal,
    closeTaxPackExportModal,
    resolveExportOptions,
  }
}
